function getQueryString (name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) return unescape(r[2])
  return null
}

function getCourseId (name, url) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  var r = url.split('?')[1].match(reg)
  if (r != null) return unescape(r[2])
  return null
}

// 根据位数补零函数
export function PrefixInteger (num, n) {
  return (Array(n).join(0) + num).slice(-n)
}
export default {
  getQueryString,
  getCourseId

}



// WEBPACK FOOTER //
// ./src/utils/urlUtil.js